import { useState, useEffect, useRef } from 'react';
import { formatCallTime } from '@/shared/utils';

export const useSessionTimer = (sessionStartTime?: number) => {
  const [elapsedSeconds, setElapsedSeconds] = useState(0);
  const startTimeRef = useRef<number>();
  const timerRef = useRef<NodeJS.Timeout>();

  // Initialize timer when sessionStartTime is available
  useEffect(() => {
    // Don't do anything if we don't have a valid start time
    if (!sessionStartTime) return;

    // Store the session start time in a ref
    startTimeRef.current = sessionStartTime;

    // Calculate initial elapsed time
    const initialElapsed = Math.floor((Date.now() - sessionStartTime) / 1000);
    setElapsedSeconds(initialElapsed);

    // Start the timer
    timerRef.current = setInterval(() => {
      if (startTimeRef.current) {
        const newElapsed = Math.floor(
          (Date.now() - startTimeRef.current) / 1000,
        );
        setElapsedSeconds(newElapsed);
      }
    }, 1000);

    // Cleanup
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = undefined;
      }
    };
  }, [sessionStartTime]);

  return {
    elapsedSeconds,
    formattedTime: formatCallTime(elapsedSeconds),
  };
};
